import { styled } from '@mui/system';
import { Box } from '@mui/material';

export const LaborLawsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
}));

export const LaborLawsGrid = styled(Box)(({ theme }) => ({
  width: 'fit-content',
  backgroundColor: theme.palette.background.secondary,
  borderRadius: '8px',
  padding: theme.spacing(2),
}));

export const LawsList = styled('ul')(() => ({
  listStyle: 'none',
  padding: 0,
  margin: 0,
}));

export const LawItem = styled('li')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '200px 1fr',
  gap: theme.spacing(2),
  padding: theme.spacing(1.5, 0),
  borderBottom: `1px solid ${theme.palette.divider}`,
  '&:last-child': {
    borderBottom: 'none',
  },
}));
